import { Terminal } from '../types/terminal'
import { GET_TERMINAL_INFO_BY_ID, SET_APP_STATE } from '../constants/actions'
import { AppState } from '.'
import { Reservation } from '../types/reservation'
import { UiConfig } from '../types/uiConfig'

interface State {
  error?: string
  terminal?: Terminal
}

const initialState: State = {
  error: '',
  terminal: undefined,
}

const reducer = (state: State = initialState, action: any): State => {
  switch (action.type) {
    case GET_TERMINAL_INFO_BY_ID:
      return { ...state, terminal: action.payload }
    case SET_APP_STATE: {
      if (action.payload.terminal) {
        return { ...state, ...action.payload.terminal }
      }
    }
    default:
      return state
  }
}

export default reducer

export const isVehicleBoardingCardNeedReducer = (state: AppState) => {
  const uiConfig = state.reservation.uiConfig
  const reservation = state.reservation.reservation
  const terminal = state.terminal.terminal
  if (uiConfig && reservation && reservation.route.portFrom && terminal && terminal.allowVehicleCardPrint) {
    return uiConfig.separateCoupon.includes(`${reservation.route.portFrom}:${reservation.route.ship}`)
  } else {
    return false
  }
}

export const isReservationELConnectionHide = ({
  uiConfig,
  reservation,
}: {
  uiConfig?: UiConfig
  reservation?: Reservation
}) => {
  if (uiConfig && reservation && reservation.route.portFrom) {
    return uiConfig.allowEl.includes(`${reservation.route.portFrom}:${reservation.route.ship}`)
  } else {
    return false
  }
}

export const isELConnectionHideSelector = (state: AppState) => {
  const uiConfig = state.reservation.uiConfig
  const reservation = state.reservation.reservation
  return isReservationELConnectionHide({ uiConfig, reservation })
}

export const isDangerousGoodsShowSelector = (state: AppState) => {
  const uiConfig = state.reservation.uiConfig
  const reservation = state.reservation.reservation
  if (uiConfig && reservation && reservation.route.portFrom) {
    return !uiConfig.allowIMO.includes(`${reservation.route.portFrom}:${reservation.route.ship}`)
  } else {
    return true
  }
}
